<template>
  <div>
    <div class="dt-page--top-bar v1">
      <div class="search">
        <InputField :placeholder="'Search'" :config="{
          borderStyle: 'bottom',
          maxWidth: '200px',
          minWidth: '200px',
          width: '200px',
        }" @keyup="onSearchInputKeyup"></InputField>
        <Dropdown :style="{ maxWidth: '200px', paddingLeft: '20px', width: '200px !important' }"
          :options="edi_order_statusTV" :selected="edi_order_statusTV.find((e) => e.value == selectedStatus)"
          :placeholder="'Status'" deselect borderbottom v-on:selectedChange="(e) => onDropdownChange('status', e)">
        </Dropdown>
      </div>



      <div class="right-container ut-colcen">
        <div class="ut-flex">
          <button class="dt-button v5 s8" @click="onEdiListLoad">
            {{ $t("Back") }}
          </button>
        </div>
      </div>
    </div>
    <div class="dt-page--body">
      <NTable :id="'distribution-orders-order_list'" :headers="headers" :items="list" class="order_list h1"
        :config="orderTableConfig" :loadingFlag="loadingFlag" @scrollnext="onListScroll">
        <template v-slot:item="{ item, tdcon }">
          <tr :class="{
            selected: selectedRow(item),
          }">
            <td @click="onRowClicked(item)" v-bind="tdcon('order_date')">
              <span style="font-weight: bold">{{ item["order_date"] }}</span>
            </td>
            <td @click="onRowClicked(item)" v-bind="tdcon('order_reference')">
              <span style="font-weight: bold">{{ item.order_reference }}</span>
            </td>
            <td @click="onItemClicked(item)" v-bind="tdcon('order_id')">
              <span style="font-weight: bold">{{ item.order_id }}</span>
            </td>
            <td @click="onAccountClicked(item)" v-bind="tdcon('account_name')">
              <span style="font-weight: bold" class="txtov">{{ item["account_name"] }}</span>
            </td>
            <td v-bind="tdcon('deliver_date')">
              <span>{{ item.deliver_date }}</span>
            </td>
            <td v-bind="tdcon('receiver')">
              <span>{{ item["receiver"] }}</span>
            </td>
            <td v-bind="tdcon('status')">
              <span>{{ item.order_status }}</span>
            </td>

            <td v-bind="tdcon('account_date')">
              <div class="ut-flex">
                <div style="min-width: 20px">
                  <div class="dt-checkbox v2 s1 disabled2">
                    <input type="checkbox" :name="'paid_flag'" :id="'paid_flag'" :checked="item['accounted_date']"
                      :disabled="true" />
                    <div class="checkmark"></div>
                  </div>
                </div>
                <div style="flex: 1; margin-left: 4px">
                  <span v-if="item['accounted_date']">{{
                    item["accounted_date"]
                  }}</span>
                </div>
              </div>
            </td>
            <td v-bind="tdcon('invoice')">
              <span class="txtov" :title="item['invoice']">{{
                item["invoice"]
              }}</span>
            </td>
            <td v-bind="tdcon('edi_check')">
              <span class="txtov" :title="item['edi_check']">{{
                item["edi_check"]
              }}</span>
            </td>
          </tr>
        </template>
      </NTable>

      <div class="ut-flex dt-page--body--bottom-bar">
        <div class="ut-flex" style="flex: 6">
          <button @click="openGln" style="text-transform: uppercase" class="dt-button v5 s8">
            {{ $dft.capHead($t("check_gln_no")) }}
          </button>
          <button @click="openBarcode" style="text-transform: uppercase" class="dt-button v5 s8">
            {{ $t("check_barcodes") }}
          </button>
          <button @click="refresh" style="text-transform: uppercase" class="dt-button v5 s8">
            {{ $dft.capHead($t("refresh")) }}
          </button>
        </div>
        <div class="ut-flex" style="flex: 8; justify-content: flex-end">
          <button @click="sendConfirmedOrders" style="text-transform: uppercase" class="dt-button v5 s8">
            {{ $t("send_confirmed_orders") }}
          </button>
          <button @click="ediRemoveRefused" style="text-transform: uppercase" class="dt-button v5 s8">
            {{ $t("edi_remove_refused") }}
          </button>
          <button @click="ediSetToPrepare" style="text-transform: uppercase" class="dt-button v5 s8">
            {{ $t("edi_set_to_prepare") }}
          </button>
          <button @click="ediSendShippingNotes" style="text-transform: uppercase" class="dt-button v5 s8">
            {{ $t("edi_send_shipping_notes") }}
          </button>
          <button @click="ediSendEdiInvoice" style="text-transform: uppercase" class="dt-button v5 s8">
            {{ $t("edi_send_edi_invoice") }}
          </button>



        </div>
      </div>
    </div>

    <ModalContainer :modalKey="'checkGlnModal'" :width="'small2'">
      <CheckGlnModal :selectedEdiOrderTab="selectedEdiOrderTab" @cancelled="onCancel" />
    </ModalContainer>
    <ModalContainer :modalKey="'checkBarcodeModal'" :width="'medium'">
      <CheckBarcodeModal :selectedEdiOrderTab="selectedEdiOrderTab" @cancelled="onCancel" />
    </ModalContainer>
    <ModalContainer :modalKey="'checkConfirmOrder'" :width="'large'">
      <CheckConfirmOrder @load="refresh" @cancelled="onCancel" />
    </ModalContainer>

  </div>
</template>

<script>
import InputField from "@plugins/text-field/input-field";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import {
  createModalMixin,
  closeModalRoute,
  openModalRoute2
} from "../../../../dt-plugins/modal/modal.mixin";
import ModalContainer from "@dtplugins/modal/modal-container";
//store
import { distributionOrderActions } from "../../store/orders/actions";
import { DistributionStoreNamespace as storeNS } from "../../store";
import { Subject } from "rxjs";
import { mapGetterObject, mapActionObject } from "../../../../store/global";
import { distributionOrderGetters } from "../../store/orders/getters";
//modal
import { OrderService } from "../../services/order.service";
import { createTV } from "../../../../models/text-value.model";
import {
  distributionOrderListLDTRoutes,
  distributionAccountListLDTRoutes,
  getDistributionOrderDetailsSelectable,
} from "../../router/routes";
//component
import { NotificationService } from "../../../../dt-plugins/notification/notification.service";
// import AccountDateModal from "./account-date-modal";
import { isChecked } from "../../../../utility";
import CheckBarcodeModal from './check-barcode-modal.vue'
import CheckGlnModal from './check-gln-modal.vue';
import CheckConfirmOrder from './check-confirm-order.vue'
export default {
  mounted: async function () {

  },
  props: ['selectedEdiOrderTab', 'loadingFlag'],
  components: {
    InputField,
    NTable,
    ModalContainer,
    CheckBarcodeModal,
    CheckGlnModal,
    CheckConfirmOrder
  },
  data() {
    return {
      orderData: null,
      orderTableConfig: createNTableConfig({
        scrollNextThreshold: 95,
        rowHeight: 40,
      }),
      searchString: "",
      searchSubject$: new Subject(),
      selectedClickedOrder: null,
      loadingGif: true,
      isEdiLoading: false,
      selectedStatus: null,
      searchModel: {
        searchString: "",
        order_month: "",
        accounted_period: "",
        account_id: 0,
        status: "",
        is_shipped: null,
        shipping_date: null,
      },
    };
  },
  mixins: [
    createModalMixin("checkBarcodeModal"),
    createModalMixin("checkGlnModal"),
    createModalMixin("checkConfirmOrder"),

  ],
  computed: {
    ...mapGetterObject(storeNS, distributionOrderGetters),
    list: function () {
      return this.selectedEdiOrderTab?.orders || [];
    },
    edi_order_statusTV: function () {
      return createTV(
        this.selectedEdiOrderTab?.edi_order_status,
        this.$t("value"),
        "value"
      );
    },
    headers: function () {
      return [
        createTableHeader("order_date", { text: 'Date', mw: 100 }),
        createTableHeader("order_reference", { text: 'Order Ref', mw: 100 }),
        createTableHeader("order_id", { text: "Internal ID" }),
        createTableHeader("account_name", { text: 'Account' }),
        createTableHeader("deliver_date", { text: 'Delivery Date' }),
        createTableHeader("receiver"),
        createTableHeader("status"),
        createTableHeader("account_date"),
        createTableHeader("invoice"),
        createTableHeader("edi_check", { text: 'GLN' }),

      ];
    },

  },

  created() { },

  methods: {
    ...mapActionObject(storeNS, distributionOrderActions),
    openBarcode() {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "check_barcode_modal",
        },
      });
    },
    openGln() {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "check_gln_modal",
        },
      });
    },
    onEdiListLoad: function () {
      this.$emit("load", false);
    },
    sendConfirmedOrders: async function () {
      const order_ids = this.selectedEdiOrderTab?.orders.filter(o => o.order_status == 'confirmed').map(ord=>ord.order_id).join(',') || ''
      if (!order_ids) {
        NotificationService.showNotification({
          text: this.$t('order_unconfirmed'),
          timeout: 2000,
          type: "normal",
        });
      }
      else {
        const res = await OrderService.sendConfirmedOrdersToEdi(order_ids);
        NotificationService.showNotification({
          text: this.$t('edi_confirmation_sent_successfully'),
          timeout: 2000,
          type: "normal",
        });
      }

    },
    ediRemoveRefused: async function () {
      const order_ids = this.selectedEdiOrderTab?.orders.filter(o => o.order_status == 'confirmation_sent').map(ord=>ord.order_id).join(',') || ''
      if (!order_ids) {
        NotificationService.showNotification({
          text: this.$t('edi_nothing_to_send'),
          timeout: 2000,
          type: "normal",
        });
      }
      else {
        const res = await OrderService.ediRemoveRefused(order_ids);
        NotificationService.showNotification({
          text: this.$t('edi_confirmation_sent_successfully'),
          timeout: 2000,
          type: "normal",
        });
      }
    },
    ediSetToPrepare: async function () {
      const order_ids = this.selectedEdiOrderTab?.orders.filter(o => o.order_status == 'confirmation_sent').map(ord=>ord.order_id).join(',') || ''
      if (!order_ids) {
        NotificationService.showNotification({
          text: this.$t('edi_nothing_to_send'),
          timeout: 2000,
          type: "normal",
        });
      }
      else {
        const res = await OrderService.ediSetToPrepare(order_ids);
        NotificationService.showNotification({
          text: this.$t('edi_confirmation_sent_successfully'),
          timeout: 2000,
          type: "normal",
        });
      }
    },
    ediSendShippingNotes: async function () {
      const order_ids = this.selectedEdiOrderTab?.orders.filter(o => o.order_status == 'accounted').map(ord=>ord.order_id).join(',') || ''
      if (!order_ids) {
        NotificationService.showNotification({
          text: this.$t('edi_nothing_to_send'),
          timeout: 2000,
          type: "normal",
        });
      }
      else {
        const res = await OrderService.sendShippingNotesToEdi(order_ids);
        NotificationService.showNotification({
          text: this.$t('edi_shipping_notes_sent_successfully'),
          timeout: 2000,
          type: "normal",
        });
      }
    },
    ediSendEdiInvoice: async function () {
      const order_ids = this.selectedEdiOrderTab?.orders.filter(o => o.order_status == 'shipped').map(ord=>ord.order_id).join(',') || ''
      if (!order_ids) {
        NotificationService.showNotification({
          text: this.$t('edi_nothing_to_send'),
          timeout: 2000,
          type: "normal",
        });
      }
      else {
        const res = await OrderService.sendInvoicesToEdi(order_ids);
        NotificationService.showNotification({
          text: this.$t('edi_invoices_sent_successfully'),
          timeout: 2000,
          type: "normal",
        });
      }
    },
    refresh() {
      this.$emit("load", true);
    },
    onCancel: function () {
      closeModalRoute(this);
    },

    onListScroll: function (value) {
      console.log("OOO");
      this.scrollSubject.next(value);
    },

    onSearchInputKeyup(event) {
      this.searchString = event.target.value;
      console.log(this.searchString);
      this.basicFilter.searchString = this.searchString;
      this.fetchListReset();
    },

    selectedRow: function (order) {
      return (
        this.selectedClickedOrder &&
        this.selectedClickedOrder["order_id"] === order["order_id"]
      );
    },
    onRowClicked: function (order) {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "check_confirm_order",
          order_id: order.order_id
        },
      });
    },

    onItemClicked: function (order) {
      this.selectedClickedOrder = order;
      this.$router.push({
        name: distributionOrderListLDTRoutes.names.tab,
        params: {
          order_id: order.order_id,
          tab: "overview",
        },
      });
    },
    onAccountClicked: function (order) {
      this.selectedClickedOrder = order;
      this.$router.push({
        name: distributionAccountListLDTRoutes.names.tab,
        params: {
          account_id: order.account_id,
          tab: "overview",
        },
      });
    },

    onDropdownChange(name, data) {
      this.selectedStatus = data.value;
    },

    onShipmentClick: async function (item) {
      const { order_id } = item;
      NotificationService.showNotification({
        text: "Sending Request",
        timeout: 2000,
        type: "normal",
      });
      const res = await OrderService.shippingNotify(
        order_id,
        "0",
        this.shipmentSettingsKey
      );

      if (!res) {
        NotificationService.showNotification({
          text: "Some issue. Please contact with support",
          timeout: 2000,
          type: "error",
        });
      }
    },

    isChecked: isChecked,

    //MARK: Methods
  },
};
</script>

<style lang="scss" scoped>
.cmp-distribution-orders-order_list {
  .dt-ntable.order_list {
    --ntable-height: calc(100vh - 185px);

    @media (min-width: 320px) and (max-width: 480px) {

      th:nth-child(2),
      td:nth-child(2),
      th:nth-child(3),
      td:nth-child(3),
      th:nth-child(4),
      td:nth-child(4),
      th:nth-child(7),
      td:nth-child(7) {
        display: none;
      }
    }

    td.account_name {
      font-weight: 800 !important;
    }

    td.options {
      .option-buttons {
        display: flex;
        justify-content: flex-end;
      }
    }
  }

  // button {
  //   float: right;
  //   height: 2.5em;

  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   transition: all 0.3s ease;
  //   border-radius: 5px;
  // }
  .order-top-bar {
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;

    &>div {
      margin: 0px 10px;
    }

    // .add-button {
    //   flex: 0.4;
    //   padding: 5px;
    //   display: flex;
    //   justify-content: center;
    // }
    // .search {
    //   flex: 2;
    // }
    // .users-dropdown {
    //   flex: 2;
    // }
    .right-space {
      flex: 8;
    }

    .dropdown {
      //flex: 5;
      width: 180px;
      min-width: 220px;
      margin: 0px 10px;
    }

    .input-field-container {
      //flex: 5;
      width: 180px;
      max-width: 200px;
      margin: 0px 10px;
    }
  }

  iframe {
    width: 50px;
    height: 50px;
  }
}
</style>